import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const PaymentMethodWrapper = styled.div``;

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
`;

const InfoHeaderWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const EmptyTableTitle = styled(Typography)`
  margin-bottom: 8px;
`;

const EmptyTableDescription = styled(Typography)`
  margin-bottom: 40px;
  text-align: center;
  width: 400px;
`;

const EmptyTable = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 80px 0;

  button {
    font-size: 14px;
  }
`;

const EmptyTableText = styled(Typography)`
  margin-bottom: 16px;
`;

export {
  EmptyTable,
  EmptyTableDescription,
  EmptyTableText,
  EmptyTableTitle,
  InfoHeaderWrapper,
  PaymentMethodWrapper,
  TitleWrapper
};
